export const DEFAULT_ADMIN_CREDENTIALS = {
  username: 'admin',
  email: 'admin@emei.com',
  securityKey: 'EMEI123',
  password: 'admin123',
};

export function isDefaultAdminAttempt(loginData = {}) {
  const username = (loginData.username || '').trim().toLowerCase();
  const email = (loginData.email || '').trim().toLowerCase();
  const securityKey = (loginData.securityKey || '').trim();
  const password = (loginData.password || '').toString();

  const matchesUsername = username === DEFAULT_ADMIN_CREDENTIALS.username;
  const matchesEmail = email === '' || email === DEFAULT_ADMIN_CREDENTIALS.email;
  const matchesSecurityKey = securityKey === '' || securityKey === DEFAULT_ADMIN_CREDENTIALS.securityKey;
  const matchesPassword = password === DEFAULT_ADMIN_CREDENTIALS.password;

  return matchesUsername && matchesEmail && matchesSecurityKey && matchesPassword;
}
